import { useEffect, useLayoutEffect, useState } from 'react'

export const useOffsetTopForElId = (elId: string): [number] => {
  const [offsetTop, setOffset] = useState(0)

  const setOffsetTop = (force?: boolean) => {
    const el = document.getElementById(elId)?.getBoundingClientRect()
    if (el?.top && (offsetTop === 0 || force)) {
      setOffset(el.top)
    }
  }

  useLayoutEffect(() => {
    forceSetOffsetTop()
  }, [elId])

  const forceSetOffsetTop = () => {
    setOffsetTop(true)
  }

  useEffect(() => {
    requestAnimationFrame(() => {
      setOffsetTop()
    })
    window.addEventListener('resize', forceSetOffsetTop)
    return () => window.removeEventListener('resize', forceSetOffsetTop)
  }, [setOffsetTop])
  return [offsetTop]
}
